import type { DisplayCue } from "@expert/contentful/src/types";

export const setPreviousCues = (devices: DisplayCue[], previousDetectedDevices: string[] | undefined): DisplayCue[] => {
    if (previousDetectedDevices === undefined) return devices;

    const prevDevices = previousDetectedDevices?.map((device) => device.toLowerCase());
    return devices.map((item) => {
        if (prevDevices.includes(item.name.toLowerCase())) {
            return {
                ...item,
                isDetectedOnPreviousCall: true,
                detected: true,
            };
        }
        return item;
    });
};
